import {BaseModel} from "./base-model";
import {Nationality} from "./nationality";
import {Equipment} from "./equipment";
import {Device} from "./device";

export class Car extends BaseModel {
  vin: string;
  numberPlate: string;
  vhmdId?: Partial<Device>;
  brand?: string;
  model?: string;
  color?: string;
  parkingSpotNumber?: string;
  nationality?: Nationality;
  parkedAt?: Date;
  equipment?: Equipment
  createdAt?: Date;

  constructor(data: Car) {
    super();
    Object.assign(this, {data});
  }
}
